import { TokenPaginationEvent } from '@/models/common/token-pagination-events.model';
import { DArrowLeft, ArrowLeft, ArrowRight } from '@element-plus/icons-vue';
import { defineComponent } from 'vue';
import { DEFAULT_LIMIT, DEFAULT_PAGE_SIZE_LIST } from '@/constants/common/constants';

const icons = {
  DArrowLeft,
  ArrowLeft,
  ArrowRight,
};

export default defineComponent({
  name: 'TokenPagination',
  props: {
    hasNextPage: {
      type: Boolean,
      default: false,
    },
    hasPrevPage: {
      type: Boolean,
      default: false,
    },
    itemPerPage: {
      type: Number,
      default: DEFAULT_LIMIT,
    },
    isLimitVisible: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    TokenPaginationEvent.CHANGE_LIMIT,
    TokenPaginationEvent.NEXT_PAGE,
    TokenPaginationEvent.PREV_PAGE,
    TokenPaginationEvent.UPDATE_PAGINATION,
    TokenPaginationEvent.RESET_PAGINATION,
  ],
  setup(props, { emit }) {
    const changePageHandler = (pageEvent: TokenPaginationEvent): void => {
      emit(pageEvent);
    };
    const changeItemPerPage = (itemPerPage: number): void => {
      emit(TokenPaginationEvent.CHANGE_LIMIT, itemPerPage);
    };

    return {
      DEFAULT_PAGE_SIZE_LIST,
      changePageHandler,
      changeItemPerPage,
      TokenPaginationEvent,
      icons,
    };
  },
});
